<template>
  <Card :title="$t('global.location')">
    <div class="d-flex flex-column align-items-center">
      <LoadingState v-if="planStatus.isLoading" :size="30" />
      <ErrorState v-if="planStatus.isErrored" />
      <template v-else-if="plan">
        <Logo :logo="locationLogo" :size="150" />
        <h1 class="mt-2">{{ plan.location.name }}</h1>
      </template>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import { computed } from "@vue/composition-api";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import Logo from "@/components/display/Logo";

export default {
  name: "PlanLocation",
  components: {
    Card,
    Logo,
    LoadingState,
    ErrorState,
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
    planStatus: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    // name of the logo for the location card
    const locationLogo = computed(() => `location-${props.plan.location.country.toLowerCase()}`);

    return {
      locationLogo,
    };
  },
};
</script>
<style lang="scss" scoped></style>
